import React, { useMemo, VFC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDangerousHTML } from '../../utils/hooks'
import StickyWarning from './StickyWarning'

export const IndividualTMEU: VFC<{ stickWarning?: boolean }> = ({ stickWarning }) => {
    const { t } = useTranslation()
    const prefix = 'footer:individual.TMEU'
    const { p } = useDangerousHTML()

    const warning = useMemo(() =>
        <p>
            <strong>{t(`${prefix}.retailTraders.header`)} </strong>
            {t(`${prefix}.retailTraders.text`)}
        </p>, [t])

    return <>
        {stickWarning
            ? <StickyWarning>
                {warning}
            </StickyWarning>
            : warning}
        <p>
            <strong>{t(`${prefix}.profTraders.header`)} </strong>
            {t(`${prefix}.profTraders.text`)}
        </p>
        <p>
            <strong>{t(`${prefix}.company.header`)} </strong>
            {t(`${prefix}.company.text`)}
        </p>
        {p(t(`${prefix}.cyprus`))}
        <p> {t(`${prefix}.text`)}</p>
    </>
}
